export default function FileIcon() {
  return <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.5507 2C18.5507 0.895431 17.6553 0 16.5507 0H2C0.895431 0 0 0.895431 0 2V4V27.8261V30C0 31.1046 0.895431 32 2 32H38C39.1046 32 40 31.1046 40 30V6C40 4.89543 39.1046 4 38 4H20.5507C19.4462 4 18.5507 3.10457 18.5507 2Z" fill="#F4C842"/>
    </g>
  </svg>
}